<template>
	<div id="app">
		<!-- 全局Loading -->
		<div class="global-loading" v-if="isGlobalLoading">
			<div class="loading-spinner">
				<div class="spinner-ring"></div>
				<p class="loading-text">{{ loadingText }}</p>
			</div>
		</div>
		
		<el-container v-else>
			<el-aside :width="showAside?'124px':'0px'" v-if="showAside">
				<left-aside></left-aside>
			</el-aside>
            <el-container>
                <el-header height="46px" v-if="noneHeaderRouters.indexOf($route.name) < 0">
                    <page-header></page-header>
                </el-header><!-- :style="noneHeaderRouters.indexOf($route.name) < 0?'padding-top: 0;':''" -->
                <el-main :class="[$route.name == 'Editer'? 'editer': noneAsideRouters.indexOf($route.name) > -1? 'login': '']" >
                    <common-component></common-component>
                    <div class="wrapper">
                        <!-- <breadcrumb></breadcrumb> -->
                        <div class="main">
                            <!-- <transition name="el-zoom-in-bottom" :duration="100"> -->
                            <keep-alive>
                                <router-view v-if="$route.mata && $route.mata.keepAlive" />
                            </keep-alive>
                            <router-view v-if="$route.mata && $route.mata.keepAlive"/>
                            <router-view v-else />
                            <!-- </transition> -->
                        </div>
                    </div>
                </el-main>
            </el-container>
		</el-container>

	</div>
</template>
<script>
import LeftAside from "./components/LeftAside";
import PageHeader from './components/PageHeader';
import Breadcrumb from "./components/Breadcrumb";
import { mapGetters } from "vuex";
import CommonComponent from './components/CommonComponent.vue';

export default {
	data() {
		return {
			showAside: false,
			noneAsideRouters: ["Editer", "Login", "Signup", "Forget", ],
            noneHeaderRouters: ["Editer", "Login", "Signup", "Forget", ], //"TermDetail", "MemoryDetail", "ToolsAlignDetail", "ToolsAlignDetailTiled", "ToolsTermExtractionDetail", "ToolsQADetail", "ToolsDetectorDetail",
            deferredPrompt: null,
            isGlobalLoading: true,
            loadingText: '正在加载中...',
        };
	},
	components: {
		LeftAside,
        PageHeader,
		Breadcrumb,
        CommonComponent,
	},
	computed: {
		...mapGetters({
			isLogin: "user/loginStatus",
		}),
	},
created() {
        this.checkLoginState();
        if (this.noneAsideRouters.indexOf(this.$route.name) > -1) {
			this.showAside = false;
		} else {
			this.showAside = true;
		}
        
    },
	mounted() {
		// console.log('环境变量：',process.env)
		// Initialize the chat plugin when component mounts
		this.initChatPlugin();
		this.initPWA();
		// 延迟隐藏loading，确保内容加载完成
		setTimeout(() => {
			this.isGlobalLoading = false;
		}, 1000);
	},
	watch: {
		$route(to, from) {
            // console.log(this.$route);
			if (this.noneAsideRouters.indexOf(to.name) > -1) {
				this.showAside = false;
			} else {
				this.showAside = true;
			}
            
            // 检查路由是否需要显示loading
            if (to.meta && to.meta.permission) {
				this.loadingText = `正在加载${to.meta.title || '页面'}...`;
			}
		}, 
		// Watch login status changes to load/unload the plugin
		isLogin: {
			handler(newStatus, oldStatus) {
				if (newStatus && !oldStatus) {
					// User logged in, initialize the plugin
					this.loadingText = '正在加载用户数据...';
					this.$nextTick(() => {
						this.initChatPlugin();
					});
				} else if (!newStatus && oldStatus) {
					// User logged out, remove the plugin
					this.removeChatPlugin();
				}
			},
			immediate: true
		}
	},
	methods: {
		checkLoginState() {
			this.loadingText = '检查登录状态...';
			// 确保在路由初始化完成后再显示内容
			const checkInterval = setInterval(() => {
				if (this.$router.getRoutes().length > 3) {
					clearInterval(checkInterval);
					setTimeout(() => {
						this.isGlobalLoading = false;
					}, 500);
				}
			}, 100);
		},
		initChatPlugin() {
			if (this.isLogin) {
				// 首先尝试使用匹配协议加载脚本
				this.loadChatPluginWithMatchingProtocol();
			}
		},
		loadChatPluginWithMatchingProtocol() {
			// 检查是否已经加载了脚本
			const existingScript = document.querySelector('script[src*="47.95.158.104/api/application/embed"]') || 
								 document.querySelector('script[src*="robot.languagey.cn/api/application/embed"]');
			if (existingScript) {
				existingScript.remove();
			}

			const script = document.createElement('script');
			script.async = true;
			script.defer = true;
			
			// 使用新的机器人服务地址
			script.src = "https://robot.languagey.cn/api/application/embed?protocol=https&host=robot.languagey.cn&token=8ef4573cf259db26";
			
			script.onload = () => {
				console.log('HTTPS 机器人脚本加载成功');
			};
			
			script.onerror = (error) => {
				console.log('机器人服务加载失败，使用iframe方式:', error);
				// 脚本加载失败，降级到iframe方式
				this.loadChatPluginViaIframe();
			};
			
			document.head.appendChild(script);
		},
		tryHttpFallback() {
			// 直接使用iframe方式，因为新域名支持HTTPS
			this.loadChatPluginViaIframe();
		},
		loadChatPluginViaIframe() {
			// 创建iframe来加载聊天插件
			let chatIframe = document.getElementById('chat-plugin-iframe');
			if (!chatIframe) {
				chatIframe = document.createElement('iframe');
				chatIframe.id = 'chat-plugin-iframe';
				chatIframe.style.position = 'fixed';
				chatIframe.style.bottom = '20px';
				chatIframe.style.right = '20px';
				chatIframe.style.width = '350px';
				chatIframe.style.height = '500px';
				chatIframe.style.border = 'none';
				chatIframe.style.borderRadius = '8px';
				chatIframe.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
				chatIframe.style.zIndex = '9999';
				chatIframe.style.display = 'none';
				// 使用新的机器人服务地址
				chatIframe.src = 'https://robot.languagey.cn/ui/chat/8ef4573cf259db26';
				
				// 添加聊天按钮
				const chatButton = document.createElement('div');
				chatButton.id = 'chat-button';
				chatButton.style.cssText = `
					position: fixed;
					bottom: 20px;
					right: 20px;
					width: 60px;
					height: 60px;
					background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
					border-radius: 50%;
					display: flex;
					align-items: center;
					justify-content: center;
					color: white;
					font-size: 24px;
					cursor: pointer;
					box-shadow: 0 4px 12px rgba(0,0,0,0.15);
					z-index: 9998;
					transition: transform 0.3s ease;
				`;
				chatButton.innerHTML = '💬';
				chatButton.title = '聊天机器人';
				
				// 点击事件切换iframe显示状态
				chatButton.addEventListener('click', () => {
					if (chatIframe.style.display === 'none') {
						chatIframe.style.display = 'block';
						chatButton.style.transform = 'scale(1.1)';
						chatButton.innerHTML = '✕';
					} else {
						chatIframe.style.display = 'none';
						chatButton.style.transform = 'scale(1)';
						chatButton.innerHTML = '💬';
					}
				});
				
				// 鼠标悬停效果
				chatButton.addEventListener('mouseenter', () => {
					if (chatIframe.style.display === 'none') {
						chatButton.style.transform = 'scale(1.1)';
					}
				});
				
				chatButton.addEventListener('mouseleave', () => {
					if (chatIframe.style.display === 'none') {
						chatButton.style.transform = 'scale(1)';
					}
				});
				
				document.body.appendChild(chatIframe);
				document.body.appendChild(chatButton);
				
				console.log('聊天机器人已通过iframe方式加载 (https://robot.languagey.cn)');
			}
		},
		removeChatPlugin() {
			// Remove the script and any related elements
			const existingScript = document.querySelector('script[src*="47.95.158.104/api/application/embed"]');
			if (existingScript) {
				existingScript.remove();
			}
			
			// Remove iframe chat plugin
			const chatIframe = document.getElementById('chat-plugin-iframe');
			if (chatIframe) {
				chatIframe.remove();
			}
			
			// Remove chat button
			const chatButton = document.getElementById('chat-button');
			if (chatButton) {
				chatButton.remove();
			}
			
			// Also remove any potential chat plugin elements that might have been created
			const chatElements = document.querySelectorAll('[id*="chat"], [class*="chat"]');
			chatElements.forEach(element => {
				if (element.id.includes('chat') || element.className.includes('chat')) {
					element.remove();
				}
			});
		},
		initPWA() {
			console.log('PWA: Initializing...');
			
			// 监听应用安装事件
			window.addEventListener('appinstalled', () => {
				console.log('PWA: 应用已安装到桌面');
				this.deferredPrompt = null;
			});
		},

	}
};
</script>
<style>
/* 全局Loading样式 */
.global-loading {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 9999;
}

.loading-spinner {
	text-align: center;
	color: white;
}

.spinner-ring {
	width: 50px;
	height: 50px;
	border: 3px solid rgba(255, 255, 255, 0.3);
	border-top: 3px solid white;
	border-radius: 50%;
	animation: spin 1s linear infinite;
	margin: 0 auto 15px;
}

@keyframes spin {
	0% { transform: rotate(0deg); }
	100% { transform: rotate(360deg); }
}

.loading-text {
	font-size: 14px;
	margin: 0;
	opacity: 0.9;
}
</style>
